import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {provideDefaultConfig} from '@spartacus/core';
import {
  ConfiguratorAttributeCompositionConfig,
  ConfiguratorAttributeCompositionModule,
  ConfiguratorAttributeHeaderModule,
  ConfiguratorGroupModule,
} from '@spartacus/product-configurator/rulebased';
import {KeyboardFocusModule} from '@spartacus/storefront';
import {FormsModule} from '@angular/forms';
import {DcpConfiguratorAttributeAddonMultiValueComponent} from './dcp-configurator-attribute-addon-multi-value.component';
import {DcpConfiguratorAttributeDropDownModule} from '../dcp-configurator-attribute-dropdown/dcp-configurator-attribute-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    KeyboardFocusModule,
    FormsModule,
    ConfiguratorAttributeHeaderModule,
    DcpConfiguratorAttributeDropDownModule,
    ConfiguratorAttributeCompositionModule,
    ConfiguratorGroupModule,
  ],
  providers: [
    provideDefaultConfig({
      productConfigurator: {
        assignment: {
          AttributeType_radioGroup___addon_radio: DcpConfiguratorAttributeAddonMultiValueComponent,
        },
      },
    } as ConfiguratorAttributeCompositionConfig),
  ],
  declarations: [DcpConfiguratorAttributeAddonMultiValueComponent],
  exports: [DcpConfiguratorAttributeAddonMultiValueComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DcpConfiguratorAttributeAddonMultiValueModule {}
